import React, {useEffect, useState} from "react";
import Select from "react-select";
import API from "../service/api";
import APINOAUTH from "../service/apiNoAuth";


const colourStyles = {
    option: (styles, {isFocused}) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#dddddd" : null,
            color: 'black'
        };
    },
    control: (base) => ({
        ...base,
        "&:hover": {
            borderColor: "tomato"
        },
        borderColor: "grey",
        boxShadow: 'none'

    })
};


const GeneralSelect = ({parameters, onChanges, defaultValue, isMulti = false, isDisable = false}) => {
    const [selectedOption] = useState()
    const [placeholder, setPlaceholder] = useState('')
    const [name, setName] = useState('')
    const [value, valueSet] = useState([])
    const [options, setOptions] = useState([
        {
            value: '',
            label: ''
        }
    ])


    useEffect(() => {

        setPlaceholder(parameters.placeholder)
        setName(parameters.value)
        valueSet(parameters.defaultValue)

        if (parameters.hasOwnProperty("endpoint")) {

            switch (parameters.endpoint){
                case 'setup/project-existence': {
                    let ops = []
                    ops.push({value: 'new', label: 'New Project'})
                    ops.push({value: 'existing', label: 'Existing Project'})
                    setOptions(ops)
                    break

                }
                case 'setup/user-existence':{
                    let ops = []
                    ops.push({value: 'existing', label: 'Existing User'})
                    ops.push({value: 'new', label: 'New User'})
                    setOptions(ops)
                    break
                }
                case 'landing-page/land-use':{
                    let ops = []
                    ops.push({value: 'settlement', label: 'Settlement'})
                    ops.push({value: 'agriculture', label: 'Agriculture'})
                    ops.push({value: 'investment', label: 'Investment'})
                    ops.push({value: 'reserved', label: 'Reserved'})
                    setOptions(ops)
                    break
                }
                case 'landing-page/map-land-use':{
                    let ops = []
                    ops.push({value: 'mining', label: 'Mining'})
                    ops.push({value: 'agriculture', label: 'Agriculture'})
                    ops.push({value: 'investment', label: 'Investment'})
                    ops.push({value: 'forestry', label: 'Forestry'})
                    ops.push({value: 'reserved', label: 'Reserved'})
                    setOptions(ops)
                    break
                }
                default : {
                    if (parameters.endpoint.includes('localities/list')){
                        APINOAUTH.get(parameters.endpoint)
                            .then(response => {

                                try {
                                    let ops = []
                                    response.data.results.forEach(data => {
                                        ops.push({value: data[parameters.value], label: data[parameters.label]})
                                    })
                                    setOptions(ops)
                                } catch (e) {
                                    console.log(e)
                                }

                            })
                            .catch(error => {
                                console.error(error)
                            })
                    }else{
                        API.get(parameters.endpoint)
                            .then(response => {

                                try {
                                    let ops = []

                                    if(parameters.endpoint.includes('projects/list')){
                                        ops.push({value: 0, label : 'OTHER PROJECT'})
                                    }
                                    response.data.results.forEach(data => {
                                        ops.push({value: data[parameters.value], label: data[parameters.label]})
                                    })
                                    setOptions(ops)
                                } catch (e) {
                                    console.log(e)
                                }

                            })
                            .catch(error => {
                                console.error(error)
                            })
                    }

                }
            }

        }
    }, [parameters, parameters.endpoint])
    useEffect(() => {
        let defaultsValue = defaultValue ? options.findIndex(opt => opt.value === defaultValue) : [];
        valueSet([options[defaultsValue]])
    }, [options, defaultValue])
    return (
        <Select
            id={name}
            defalutValue={value}
            name={name}
            isMulti={isMulti}
            value={selectedOption}
            onChange={onChanges}
            options={options}
            placeholder={placeholder}
            styles={colourStyles}
            isDisabled={isDisable}
        />
    )
}
export default GeneralSelect
